import React from "react";

export default class Info extends React.Component {

    title = '';
    detail = '';

    constructor(props) {
        super(props);
        this.title = props.fieldData.title;
        this.detail = props.fieldData.detail;
    }

    render() {
        return (
            <div className="container location-wrapper mt-5 pt-5 text-center">
                <h1>{this.title}</h1>
                <p>
                    {this.detail}
                </p>
            </div>
        );
    }
}

